

require('uiUtils');

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _squid = require('squid');

var _auth = require('xo-models/src/auth');

var _choice = require('xo-models/src/choice');

var _newMember = require('xo-models/src/newMember');

var _index = require('xo-models/src/app/index');

var _fi = require('xo-models/src/fi');

var _index2 = require('xo-models/src/checkout/index');

var _checkoutIncentive = require('xo-models/src/checkoutIncentive');

require('xo-page-components/src/aside-header/directive');

require('xo-page-components/src/notYou/directive');

require('xo-tray-height/dist/directive');

require('xo-ui-components/src/accessibility/directive');

require('xo-ui-components/src/address-box/directive');

require('xo-ui-components/src/banner/directive');

require('xo-ui-components/src/dropdown/directive');

require('xo-ui-components/src/error-tooltip/directive');

require('xo-ui-components/src/message/directive');

require('xo-ui-components/src/user-assist-banner/directive');

require('xo-form-components/src/phone/phoneInput/directive');

require('../creditcard-input/directive');

require('../../three-ds/directive');

var _util = require('../../fi-contingency-list/util');

var _cardMetaData = require('../cardMetaData');

var _factory = require('./factory');

var _factory2 = require('xo-member-components/src/no-balance/factory');

var _constants = require('../../three-ds/constants');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoAddCard', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            done: '=?',
            messagetitle: '=?',
            message: '=?',
            pagetitle: '=?',
            sidebar: '=?',
            showmeftsection: '=?',
            hideparenthead: '=?',
            billingaddressupdated: '=?',
            cardmodel: '=?',
            parentCallbacks: '=?',
            selectedPromotionCardType: '=?',
            promotion: '=?',
            pageLevel: '=?',
            logout: '=?',
            phone: '=?',
            manageCardFlow: '=?',
            showBalanceFlow: '=?',
            showCancel: '=?',
            showSetPreferredFi: '=?',
            onSuccess: '=?',
            backUri: '=?',
            showIncentive: '=?',
            incentiveAmount: '=?',
            updateCardCpa: '=?',
            cause: '=?'
        },
        controller: ['$scope', '$element', function ($scope, $element) {

            $scope.isCPAEligible = $scope.cause === 'cpa';
            $scope.address_box = {
                changeFn: function changeFn(type) {
                    _logger.$logger.info('xo-address-box_changeFn - ' + type);
                    _uiRouter.$state.go('^.addBilling', {
                        flow_type: 'edit'
                    });
                }
            };

            // Ensure no incentive-related actions are taken unless
            // explicityly passed 'true' from the xo-add-card page
            // Also ensure there are no duplicate titles
            $scope.showIncentive = Boolean($scope.showIncentive);
            var isNoBalanceEligible = _factory2.$NoBalanceFactory.get().eligible;

            $scope.showPageTitle = Boolean($scope.pagetitle && !($scope.isNmjDesign2 || $scope.isNmjDesign3) && !isNoBalanceEligible);
            $scope.showMessageTitle = Boolean($scope.messagetitle);
            $scope.showMessageBanner = !$scope.sidebar && !$scope.showIncentive && !isNoBalanceEligible;
            $scope.showNoBalanceHeaderAndNoFiContingency = isNoBalanceEligible && _uiRouter.$stateParams.message === 'NEED_CREDIT_CARD';

            (0, _squid.$populate)($scope, {
                cart: _index2.$CheckoutCartModel.instance($scope.token),
                auth: _auth.$AuthModel.instance(),
                billingAddresses: _fi.$BillingAddressesModel.instance(),
                checkoutSession: _index2.$CheckoutSessionModel.instance($scope.token).retrieve({
                    contingencies: {
                        NEED_CREDIT_CARD: angular.noop,
                        EXPIRED_CREDIT_CARD: angular.noop
                    }
                }),
                flowEligibility: _index2.$FlowEligibilityModel.instance($scope.token).retrieve({
                    params: {
                        geolocation: _squid.$meta.geolocation,
                        localeCountry: _squid.$locale.country
                    }
                }),
                tokenizedWalletInfoModel: _index.$TokenizedWalletInfoModel.instance($scope.token).retrieve(),
                checkoutAppData: _index2.$CheckoutAppDataModel.instance($scope.token).retrieve()
            }).then(function () {
                if ($scope.auth) {
                    $scope.formattedNameInformal = (0, _squid.formatNameInformal)({
                        first_name: $scope.auth.first_name,
                        last_name: $scope.auth.last_name
                    }) || $scope.auth.email;
                }

                $scope.isIndiaAndBilling = _squid.$locale.country === 'IN' && $scope.cart.isBilling() && $scope.checkoutAppData.get('merchant.merchant_country', 'US') === 'IN';

                var isCreditDisallowedForMerchant = $scope.checkoutSession && $scope.checkoutSession.isCreditDisallowedForMerchant;

                if (!$scope.sidebar && isCreditDisallowedForMerchant) {
                    $scope.pagetitle = _squid.$locale.content.get('addCard.addBankDebitCard');
                    $scope.showPageTitle = true;
                }

                $scope.headingTextKey = function () {
                    if ($scope.updateCardCpa) {
                        return 'addCard.updateCardCPA';
                    } else if (isCreditDisallowedForMerchant) {
                        return 'addCard.addBankDebitCard';
                    } else if ($scope.cart.isConsumerCountry('IN') && $scope.cart.isBilling()) {

                        if ($scope.cart.isRecurringPayment() || $scope.checkoutAppData.is_wps_flow()) {
                            return 'asideHeader.not.immediate.addCreditCard';
                        } else if ($scope.cart.isReferenceTransaction()) {

                            if ($scope.checkoutAppData.isMerchantCountry('IN')) {
                                if ($scope.cart.isChargePatternImmediateOrDeferred()) {
                                    return 'asideHeader.immediate.addCard';
                                } else {
                                    return 'asideHeader.not.immediate.addCreditCard';
                                }
                            } else {
                                return 'asideHeader.not.immediate.addCreditCard';
                            }
                        }
                    }

                    return 'asideHeader.addCard';
                };

                _newMember.$NewMemberEligibility.instance().getVariant($scope.token).then(function (variant) {
                    $scope.isNmj = !$scope.sidebar && variant && (variant === 'one_page' || variant === 'design_2' || variant === 'design_3');
                    $scope.isNmjDesign1 = !$scope.sidebar && variant && variant === 'one_page';
                    $scope.isNmjDesign2 = !$scope.sidebar && variant && variant === 'design_2';
                    $scope.isNmjDesign3 = !$scope.sidebar && variant && variant === 'design_3';

                    $scope.isGreyHeader = $scope.isNmjDesign2 || $scope.isNmjDesign3;

                    if ($scope.isGreyHeader && $scope.message && $scope.message.msgs[0] && $scope.message.msgs[0].key === 'creditcard.errorExpiredCard') {
                        $scope.message.msgs = null;
                        $scope.isExpiredCard = true;
                    }

                    if ($scope.isNmj) {
                        // Set Up AddBank Link
                        $scope.disallowedInstruments = $scope.checkoutSession.get('fundingOptions').get('disallowedInstruments');
                        var hasDisallowedBank = $scope.disallowedInstruments && $scope.disallowedInstruments.some(function (fi) {
                            return fi.type === 'BANK';
                        });

                        $scope.showAddBank = (0, _squid.$feature)('enableExternalAddBank') && (!hasDisallowedBank || !$scope.disallowedInstruments);
                        $scope.addBankUri = '/webapps/hermes/add-bank?token=' + $scope.token;
                        _logger.$logger.info('external_addbank_' + ($scope.showAddBank ? 'enabled' : 'disabled'));
                    }

                    if ($scope.isNmjDesign1) {

                        var contentKey = {
                            header: '',
                            body: ''
                        };

                        if ($scope.disallowedInstruments && $scope.disallowedInstruments.length === 1) {
                            contentKey.header = 'addCard.assistHeaderHasDisallowedFi';
                            contentKey.body = 'addCard.assistBodySingleDisallowedFi';
                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_single_disallowed_FI_addcard_msg'
                            });
                        } else if ($scope.disallowedInstruments && $scope.disallowedInstruments.length > 1) {
                            contentKey.header = 'addCard.assistHeaderHasDisallowedFi';
                            contentKey.body = 'addCard.assistBodyMultiDisallowedFi';
                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_multi_disallowed_FI_addcard_msg'
                            });
                        } else {
                            contentKey.header = 'addCard.assistHeader';
                            contentKey.body = 'addCard.assistBody';
                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_has_no_FI_addcard_msg'
                            });
                        }

                        $scope.contentKey = contentKey;
                    }

                    if ($scope.isNmjDesign2 || $scope.isNmjDesign3) {
                        var headerMsg = void 0;
                        var userName = $scope.auth.first_name ? $scope.auth.first_name : $scope.auth.email;

                        if ($scope.isExpiredCard) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgExpiredCard', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_expired_card_addcard_msg'
                            });
                        } else if ($scope.disallowedInstruments && $scope.disallowedInstruments.length === 1 && $scope.showAddBank) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgHasDisallowedShowBankLink', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_single_disallowed_FI_show_addbank_link_addcard_msg'
                            });
                        } else if ($scope.disallowedInstruments && $scope.disallowedInstruments.length === 1 && !$scope.showAddBank) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgHasDisallowedHideBankLink', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_single_disallowed_FI_hide_addbank_link_addcard_msg'
                            });
                        } else if ($scope.disallowedInstruments && $scope.disallowedInstruments.length > 1 && $scope.showAddBank) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgHasMultiDisallowedShowBankLink', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_multi_disallowed_FI_show_addbank_link_addcard_msg'
                            });
                        } else if ($scope.disallowedInstruments && $scope.disallowedInstruments.length > 1 && !$scope.showAddBank) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgHasMultiDisallowedHideBankLink', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_multi_disallowed_FI_hide_addbank_link_addcard_msg'
                            });
                        } else if ($scope.showAddBank) {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgNoFiShowAddBank', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_has_no_FI_show_addbank_link_addcard_msg'
                            });
                        } else {
                            headerMsg = (0, _squid.$renderContent)('addCard.nmjHeaderMsgNoFiHideAddBank', { userName: userName });

                            _logger.$logger.info('checkout_fpti', {
                                'int_error_description': 'nmj_has_no_FI_hide_addbank_link_addcard_msg'
                            });
                        }
                        $scope.headerMsg = headerMsg;
                    }
                });

                return _choice.$ChoiceEligibility.instance().getVariant($scope.token).then(function (variant) {
                    var multipleFiVariants = _squid.$config.choiceExperiment && _squid.$config.choiceExperiment.multipleFi || [];

                    if (multipleFiVariants.indexOf(variant) !== -1) {
                        $scope.showMultipleFI = true;
                    }
                });
            }).then(function () {

                var logObj = {
                    'from': 'ADD_CARD',
                    'to': 'prepare_ADD_CARD',
                    'context_id': $scope.token,
                    'contingency_type': _uiRouter.$stateParams.message ? 'system_intiated' : 'user_intiated'
                };

                if ($scope.cart.isWalletTokenization()) {
                    Object.assign(logObj, {
                        'context_type': 'BA-Token',
                        'ba_token': _squid.$meta.baToken
                    });
                }

                _logger.$logger.info('checkout_fpti', logObj);

                $scope.debitCardFlow = angular.isArray($scope.flowEligibility.paymentCardProductClass) && $scope.flowEligibility.paymentCardProductClass.length === 1 && $scope.flowEligibility.paymentCardProductClass[0] === 'DEBIT';

                if ($scope.showmeftsection) {
                    $scope.showmeftsection.toggle = true;
                }

                if ($scope.hideparenthead) {
                    $scope.hideparenthead.toggle = false;
                }

                $scope.manageCardFlow = $scope.sidebar && $scope.cardmodel.card.isExisting();

                var type = $scope.selectedPromotionCardType && $scope.selectedPromotionCardType.type;

                if ($scope.checkoutSession.plccOffer && !type && $scope.promotion) {
                    _uiRouter.$state.go('^.selectCard');
                }

                $scope.showplcc = type === 'plcc';
                $scope.country = _squid.$locale.country;

                $scope.showNotYou = $scope.auth.is_auth_api_call && _squid.$util.param('source') !== 'consumerApp';

                $scope.showHiMsg = Boolean($scope.messagetitle);

                $scope.cardmodel.cardType = 'creditCard';

                if ($scope.checkoutSession.plccOffer && $scope.showplcc) {
                    $scope.cardmodel.cardType = 'privateLabel';
                    $scope.cardmodel.sponsor_id = $scope.checkoutSession.plccOffer.sponsor_id;
                }

                $scope.cardmodel.user = {
                    first_name: $scope.auth.first_name,
                    last_name: $scope.auth.last_name
                };

                $scope.cardmodel.address = $scope.billingAddresses.addresses[0];

                if ($scope.billingaddressupdated.value) {
                    $scope.billingaddressupdated = {
                        msgs: [_squid.$locale.content.get('editCard.newAddressAdded')],
                        type: 'success',
                        value: true
                    };
                }

                $scope.showSidebarBackArrow = $scope.sidebar && !$scope.debitCardFlow && !$scope.checkoutSession.plccOffer && !$scope.cardmodel.card.isExisting();
                $scope.backUri = $scope.backUri || ($scope.showMultipleFI ? 'checkout.review' : 'checkout.review.sidebar.wallet');
                $scope.manageCardFlowBackUri = $scope.backUri || ($scope.showMultipeFI ? 'checkout.review.sidebar.sidebarManageWallet' : 'checkout.review.sidebar.wallet');
                _factory.$AddCardFactory.shouldDisplayAddressBox($scope.isNmjDesign1, $scope.cardmodel, false).then(function (result) {
                    $scope.displayAddressBox = result;
                });

                $scope.gotoBilling = function (address) {
                    if ($scope.pageLevel) {
                        $scope.pageLevel.message = null;
                    }
                    if (!address) {
                        if (_squid.$locale.country === 'BR') {
                            $scope.parentCallbacks.showCep();
                        } else {
                            // page transition
                            var el = $('.tokenization #sidepageAddCard');

                            if (el) {
                                el.addClass('slideLeft');
                            }
                            _uiRouter.$state.go('^.addBilling');
                        }
                    }
                };

                $scope.isUPOP = function () {
                    /*
                     * we do have a BIN lookup for C2 country to FIMS
                     * if that fails
                     *   a) buyer selects card type from dropdown and it could be CUP
                     *   b) and we are not going to get isUpop from FIMS , but C2 CUP is always upop card
                     * if that success
                     *   a) card can be of type VISA or CUP for dual cards
                     *   b) and we need to show dropdown for buyer to choose the card, eventhough we default to VISA
                     *   c) even though VISA selected , it is UPOP card
                     * if that success
                     *   a) card be of type CUP and AMEX for dual cards
                     *   b) we don't show dropdown but default to CUP
                     *   c) here both CUP and UPOP is true
                     *
                     * so checking either CUP or UPOP (for VISA)
                     * and yes only for OTP enabled country (C2 for now)
                     */
                    var needOTPForAddCard = (0, _squid.$feature)('needOTPForAddCard');
                    var isCUP = $scope.cardmodel.card && $scope.cardmodel.card.type && $scope.cardmodel.card.type === 'CUP';
                    var isUpop = $scope.cardmodel.card && $scope.cardmodel.card.isUpop;

                    return needOTPForAddCard && isCUP && isUpop;
                };

                $scope.isUpdateDebitCard = function () {
                    return _uiRouter.$stateParams.message === 'EXPIRED_DEBIT_CARD';
                };

                $scope.flag = function (field) {
                    // pass country to decide card for a country
                    return _cardMetaData.$CardMetaData.getMetaData($scope.cardmodel.card, field, _squid.$locale.country);
                };

                $scope.buttonText = function () {
                    if ($scope.updateCardCpa) {
                        return 'creditcard.updateBtn';
                    }
                    if ($scope.debitCardFlow) {
                        return 'creditcard.saveBtn';
                    }

                    var contentString = 'creditcard.addBtn';

                    if ($scope.cardmodel.card.isExisting()) {
                        contentString = 'creditcard.updateBtn';
                    } else if ($scope.isUPOP()) {
                        contentString = 'creditcard.continuetext';
                    }
                    return contentString;
                };

                $scope.cardTypeChanged = function () {
                    $scope.phone.phoneType = $scope.flag('phoneType');
                };

                function addErrorMessage(contentKey) {
                    if (contentKey) {
                        contentKey = angular.isArray(contentKey) ? contentKey[0] : contentKey;
                        var message = _squid.$locale.content.get('creditcard.' + contentKey);

                        $scope.message.msgs.push(message);
                    }
                }

                function handleContingencies(result, contentBundle, defaultErrorKey, prop) {
                    var errorData = void 0;

                    if (result.errorCodes) {
                        errorData = result;
                    } else {
                        errorData = {
                            errorCodes: result && [result['0']]
                        };
                    }
                    $scope.message = _util.$fiErrorUtil.addPageErrors(errorData, contentBundle, prop, defaultErrorKey);

                    if (window.scrollTo) {
                        window.scrollTo(0, 0);
                    }
                }

                var handleFIContingency = function handleFIContingency(contingency, body) {
                    var contingencyName = body.contingencyName,
                        errorDetails = body.errorDetails;

                    var errorProperty = void 0;
                    var invalidModels = [];
                    var defaultError = 'INTERNAL_ERROR';

                    if ($scope.sidebar) {
                        $scope.$emit('SidebarError');
                    }

                    // for certain contingencies the error message is specific to the type of Checkout flow
                    switch (contingencyName) {
                        case 'CARD_BRAND_NOT_SUPPORTED':
                        case 'CARD_NOT_ALLOWED':
                        case 'CARD_NUMBER_WITH_BAD_BIN':
                        case 'CUP_CARD_NOT_ALLOWED':
                            var flowType = _squid.$config.checkoutFlowType;

                            errorProperty = contingencyName + '_' + flowType;
                            break;
                        case 'VALIDATION_ERROR':
                            defaultError = 'VALIDATION_ERROR_GENERIC';

                            // highlight the fields mentioned in the validation_error response as invalid
                            var _$fiErrorUtil$mapVali = _util.$fiErrorUtil.mapValidationErrorToModel(errorDetails.invalidFields);

                            errorProperty = _$fiErrorUtil$mapVali.errorProperty;
                            invalidModels = _$fiErrorUtil$mapVali.invalidModels;
                            _util.$fiErrorUtil.highlightInvalidFields(invalidModels, $element);
                            break;
                        default:
                            errorProperty = contingencyName;
                            break;
                    }

                    $scope.billingaddressupdated.value = false;
                    $scope.message = _util.$fiErrorUtil.addPageErrorByErrorName('addCardFIErrors', errorProperty, defaultError);

                    var fpti_payload = {
                        'from': 'ADD_CARD',
                        'to': 'process_ADD_CARD',
                        'context_id': $scope.token,
                        'int_error_code': errorProperty,
                        'int_error_description': errorDetails,
                        'error_source': 'filifecycleserv'
                    };

                    if ($scope.cart.isWalletTokenization()) {
                        Object.assign(fpti_payload, {
                            'context_type': 'BA-Token',
                            'ba_token': _squid.$meta.baToken
                        });
                    }

                    _logger.$logger.info('checkout_fpti', fpti_payload);

                    if (window.scrollTo) {
                        window.scrollTo(0, 0);
                    }

                    if (errorDetails && errorDetails.invalidFields && errorDetails.invalidFields[0] === 'BILLING_ADDRESS') {
                        return _factory.$AddCardFactory.shouldDisplayAddressBox($scope.isNmjDesign1, $scope.cardmodel, true).then(function (result) {
                            $scope.displayAddressBox = result;
                        });
                    }
                };

                $scope.cancelFn = function () {
                    // Use callback provided by parent route if there
                    if ($scope.parentCallbacks.cancel) {
                        return $scope.parentCallbacks.cancel();
                    }

                    // For multiple FI variant, route back to review page
                    if ($scope.showMultipleFI) {
                        if ($scope.manageCardFlow) {
                            return _uiRouter.$state.go('checkout.review.sidebar.sidebarManageWallet');
                        }
                        return _uiRouter.$state.go('checkout.review');
                    }

                    if ($scope.sidebar) {
                        if (!$scope.checkoutSession.plccOffer) {
                            return _uiRouter.$state.go('checkout.review.sidebar.wallet');
                        } else {
                            return _uiRouter.$state.go('^.selectCard');
                        }
                    }
                    $scope.done();
                };

                function initiateOTP() {
                    var resolveOTP = new _fi.$ResolveOTP({ id: $scope.cardmodel.id });

                    return resolveOTP.action('init', {
                        data: {
                            phone: {
                                country_code: $scope.phone.IntDialingCountryCode,
                                number: $scope.phone.telephone
                            }
                        },
                        resultModel: {},
                        success: function success() {
                            return _uiRouter.$state.go('.confirmUpop');
                        },
                        error: function error() {
                            return handleContingencies({}, 'confirmUpop', 'declineMessage');
                        },
                        contingencies: {
                            INIT_OTP_CONTINGENCY: function INIT_OTP_CONTINGENCY(name, result) {
                                // prop for last 4 digits of card in error message
                                var prop = {
                                    number: $scope.cardmodel && $scope.cardmodel.card && $scope.cardmodel.card.last4()
                                };

                                handleContingencies(result, 'confirmUpop', 'declineMessage', prop);
                                _util.$fiErrorUtil.addFieldErrors(result, $element);
                            },
                            DEFAULT: function DEFAULT() {
                                return handleContingencies({}, 'confirmUpop', 'declineMessage');
                            }
                        }
                    });
                }

                function handleCheckoutSession(result, isNewCard) {
                    if ($scope.cardmodel && $scope.cardmodel.cardType === 'privateLabel') {
                        delete $scope.checkoutSession.plccOffer;
                    }

                    delete $scope.checkoutSession.errorData;

                    var cardAdded = $scope.cardmodel && $scope.cardmodel.card;
                    var numberAdded = void 0;
                    var cardTypeAdded = void 0;

                    if (cardAdded) {
                        numberAdded = angular.isString(cardAdded.number) && cardAdded.number.replace(/\s/g, '');
                        cardTypeAdded = cardAdded.type;
                    }

                    var last4Added = angular.isString(numberAdded) && numberAdded.substr(numberAdded.length - 4);
                    var cvvData = $scope.checkoutSession && $scope.checkoutSession.cvvData;
                    var last4ToUse = void 0;
                    var cardTypeToUse = void 0;

                    if (cvvData) {
                        last4ToUse = cvvData.number;
                        cardTypeToUse = cvvData.type;
                    }

                    if (last4ToUse === last4Added && cardTypeAdded === cardTypeToUse) {
                        $scope.checkoutSession.set('cvvData.security_code', $scope.cardmodel.get('card.security_code'));
                        $scope.checkoutSession.set('cvvData.lastAddedCard', true);
                    }

                    var updateCardSidebarMessage = (0, _squid.$renderContent)('wallet.cardUpdated', {
                        type: cardTypeAdded,
                        number: last4Added
                    });
                    var updateCardPageMessage = (0, _squid.$renderContent)('smallToolTip.cardUpdated');
                    var addCardMessage = (0, _squid.$renderContent)($scope.updateCardCpa ? 'addCard.updateCardCPASuccess' : 'smallToolTip.cardAdded');
                    var msgs = [addCardMessage];
                    var createdOffer = Boolean($scope.createOfferModel && $scope.createOfferModel.createdOffer());

                    if (createdOffer) {
                        var createdOfferMessage = (0, _squid.$renderContent)('smallToolTip.incentiveCreated', {
                            incentiveAmount: $scope.incentiveAmount
                        });

                        msgs = [createdOfferMessage];
                    } else if (!isNewCard) {
                        msgs = $scope.manageCardFlow ? [updateCardSidebarMessage] : [updateCardPageMessage];
                    }

                    $scope.checkoutSession.message = {
                        type: 'success',
                        msgs: msgs
                    };
                    // in case user saw No Balance banner and added card successfully - prevent showing the same banner on the review page
                    _factory2.$NoBalanceFactory.markAsAlreadyShown();
                    $scope.done();
                }

                var is3DSRequried = function is3DSRequried(result) {
                    return result && result.confirmation && result.confirmation.is3DSrequired || false;
                };

                var initiate3DS = function initiate3DS(data) {
                    var confirmation = data && data.confirmation && data.confirmation.three_ds_confirmation_details;

                    var supplement = confirmation.supplemental_data_details;

                    $scope.threeDSData = {
                        cardBin: supplement.bank_identification_number,
                        networkLogo: supplement.network_logo,
                        ddsUrl: supplement.device_data_collection_url,
                        jwtInfo: {
                            jwtIssuer: supplement.jwt_issuer,
                            jwtOrgUnitId: supplement.jwt_org_unit_id,
                            jwtDuration: supplement.jwt_duration
                        },
                        initiate3dsData: {
                            fundingId: $scope.cardmodel.id,
                            confirmationMethod: 'ONLINE_SECURE_AUTHENTICATION',
                            bypassConfirmationProcess: false,
                            referenceId: confirmation.reference_id,
                            cvv: $scope.cardmodel.get('card.security_code')
                        },
                        integrationType: 'ADD_CARD'
                    };
                    $scope.showThreedsPopup = true;
                };

                $scope.hideModal = function () {
                    $scope.oncomplete3ds('USER_CANCELED');
                };

                // call on submit and on resolving contingency 3ds
                // default threeDSStatus as false, this is required to pass the addCard 3DS resolution data to symphony,
                // symphony will then inform about the status to risk to avoid 3DS contingency again during planning
                var onCardSaveSuccess = function onCardSaveSuccess() {
                    var threeDSStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                    var isNewCard = $scope.isNewCard;

                    if ($scope.cart.isWalletTokenization()) {
                        var fpti_payload = {
                            'from': 'ADD_DEBIT_CARD',
                            'to': 'process_ADD_debit_card',
                            'context_id': $scope.token,
                            'context_type': 'BA-Token',
                            'ba_token': _squid.$meta.baToken,
                            'fi_id': $scope.cardmodel.id
                        };
                        var handleNotifyChangeContingency = function handleNotifyChangeContingency(name) {
                            fpti_payload.int_error_desc = name + '_addedButCannotUse';
                            fpti_payload.error_source = 'paymentapiplatformserv';
                            fpti_payload.int_error_code = name;
                            _logger.$logger.info('tokenized_wallet', fpti_payload);
                            if ($scope.message) {
                                $scope.message.msgs = [];
                                $scope.message.type = 'info';
                            }
                            addErrorMessage('addedButCannotUse');
                        };

                        $scope.checkoutSession.fundingOptions.action('notifyChange', {
                            resultModel: $scope.checkoutSession,
                            data: {
                                planId: $scope.cardmodel.id,
                                operation: 'ADDED'
                            },
                            success: function success(result) {
                                _logger.$logger.info('tokenized_wallet', fpti_payload);
                                handleCheckoutSession(result, isNewCard);
                            },
                            contingencies: {
                                NOTIFY_CHANGE_FUNDING_CONTINGENCY: handleNotifyChangeContingency
                            }
                        });
                    } else {
                        var _fpti_payload = {
                            'from': 'ADD_CARD',
                            'to': 'process_ADD_CARD',
                            'context_id': $scope.token,
                            'context_type': _squid.$integration.isFlow('WPS') ? 'WPS-token' : 'EC-token',
                            'fi_id': $scope.cardmodel.id
                        };

                        _logger.$logger.info('checkout_fpti', _fpti_payload);

                        return _angular.$q.when().then(function () {
                            // setPreferredFI checkbox is checked
                            if ($scope.showSetPreferredFi && $('#makeFiPreferred').is(':checked')) {
                                _logger.$logger.info('set_preferredFI_checked');

                                // set preferred FI before updating
                                var preferredFi = new _fi.$PreferredFi({
                                    preferred: [$scope.cardmodel.id]
                                });

                                return preferredFi.save({
                                    success: function success() {
                                        _logger.$logger.info('SET_PREFERREDFI_SUCCESS', {
                                            preferred: [$scope.cardmodel.id]
                                        });
                                    },
                                    transientError: true,
                                    error: function error(err) {
                                        return _logger.$logger.error('SET_PREFERREDFI_ERROR', { error: err });
                                    }, // log the error but fails silently because card is added
                                    contingencies: {
                                        DEFAULT: function DEFAULT(name, contingency) {
                                            return _logger.$logger.info('SET_PREFERREDFI_CONTINGENCY', name);
                                        }
                                    }
                                });
                            }
                        }).then(function () {
                            return (0, _angular.$q)(function (resolve, reject) {
                                if ($scope.showIncentive) {
                                    var fptiData = {
                                        from: 'FI_addCardAccount',
                                        to: 'process_FI_addCardAccount_incentive',
                                        add_incentive: 0,
                                        context_id: $scope.token,
                                        add_incentive_reason: ''
                                    };

                                    (0, _squid.$populate)($scope, {
                                        evaluateCheckoutOfferEligibilityModel: _checkoutIncentive.$EvaluateCheckoutOfferEligibilityModel.instance().retrieve(),
                                        getOfferProgramModel: _checkoutIncentive.$GetOfferProgramModel.instance().retrieve()
                                    }).then(function () {
                                        var createOfferData = {
                                            payer_id: $scope.auth.buyer_id,
                                            offer_program_id: $scope.evaluateCheckoutOfferEligibilityModel.getOfferProgramID(),
                                            value_issued: $scope.getOfferProgramModel.getOfferValueLowestDenom(),
                                            currency_code: $scope.evaluateCheckoutOfferEligibilityModel.getCurrencyCode()
                                        };

                                        $scope.createOfferModel = _checkoutIncentive.$CreateOfferModel.instance();

                                        return $scope.createOfferModel.save({
                                            data: createOfferData,
                                            success: function success() {
                                                if ($scope.createOfferModel.createdOffer()) {
                                                    fptiData.incentive_added = 1;
                                                    _logger.$logger.info('checkout_fpti', fptiData);
                                                    resolve('Incentive created');
                                                } else {
                                                    fptiData.add_incentive_reason = 'Offerserv_User_Not_Eligible';
                                                    _logger.$logger.info('checkout_fpti', fptiData);
                                                    resolve('Incentive not created');
                                                }
                                            },
                                            validation: function validation(_validation) {
                                                fptiData.add_incentive_reason = 'Validation_Error';
                                                _logger.$logger.info('checkout_fpti', fptiData);
                                                resolve('Validation error encountered creating incentive');
                                            },
                                            contingencies: {
                                                DEFAULT: function DEFAULT(msg, contingency) {
                                                    fptiData.add_incentive_reason = msg;
                                                    _logger.$logger.info('checkout_fpti', fptiData);
                                                    resolve('Contingency encountered creating incentive');
                                                }
                                            },
                                            error: function error() {
                                                fptiData.add_incentive_reason = 'Offerserv_Error';
                                                _logger.$logger.info('checkout_fpti', fptiData);
                                                resolve('Error encountered creating incentive');
                                            }
                                        });
                                    });
                                } else {
                                    resolve('Not eligible for incentive');
                                }
                            });
                        }).then(function () {
                            if ($scope.isUPOP()) {
                                initiateOTP();
                            } else {
                                return $scope.checkoutSession.fundingOptions.action('update', {
                                    resultModel: $scope.checkoutSession,
                                    data: {
                                        planId: $scope.cardmodel.id,
                                        threeDSResolved: threeDSStatus
                                    },
                                    success: function success(result) {
                                        return handleCheckoutSession(result, isNewCard);
                                    }
                                });
                            }
                        });
                    }
                };

                /**
                 threeDS.usercanceled=Confirmation canceled. Try again later or choose another way to pay.
                 threeDS.authentionFailed=Your Bank wasn’t able to confirm your {cardType}-{last4}. Try a different card or contact your card issuer.
                 threeDS.lookupFailed=Your card issuer wasn’t able to confirm your card. Try again later or choose another way to pay.
                 threeDS.systemError=Sorry, we weren’t able to add this card. Try a different card or contact your card issuer.
                 */
                $scope.oncomplete3ds = function (status) {
                    $scope.showThreedsPopup = false;
                    if (status === _constants.STATUS_SUCCESS) {
                        onCardSaveSuccess(true);
                    } else if (status === _constants.STATUS_API_ERROR || status === _constants.STATUS_DECLINE) {
                        var key = 'threeDS.memberDecline';
                        var card4 = $scope.cardmodel && $scope.cardmodel.card && $scope.cardmodel.card.last4();
                        var cardType = $scope.cardmodel && $scope.cardmodel.card.type;

                        $scope.message = {
                            type: 'warning',
                            msgs: []
                        };

                        $scope.message.msgs.push((0, _squid.$renderContent)(key, {
                            cardType: cardType,
                            last4: card4
                        }));
                    }
                };

                $scope.onSubmit = function () {
                    if ($scope.pageLevel) {
                        $scope.pageLevel.message = null;
                    }
                    $scope.isNewCard = !$scope.cardmodel.card.isExisting();

                    if ($scope.isNewCard) {
                        delete $scope.cardmodel.id;
                    }

                    if ($('#plccAgree').is(':checked')) {
                        $scope.cardmodel.preference = true;
                    }

                    // Only initiateOTP needs to be called for unconfirmed CUP contingency. Add card call does not need to be made.
                    if ($scope.isUPOP() && $scope.cardmodel.id && ($scope.checkoutSession.get('errorData.cause') === 'NEED_AUTHENTICATED_CARD' || $scope.checkoutSession.get('errorData.cause') === 'EXPIRED_CREDIT_CARD')) {

                        initiateOTP();
                    } else {
                        $scope.cardmodel.save({
                            success: function success(result) {
                                if (is3DSRequried(result)) {
                                    initiate3DS(result);
                                } else {
                                    onCardSaveSuccess();
                                }
                            },
                            contingencies: {
                                DEFAULT: handleFIContingency
                            },
                            error: function error() {
                                return handleContingencies({}, 'creditcard', 'errorInternalError');
                            }
                        });
                    }
                };
            });
        }]
    };
});

_angular.$q;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_squid.$config;

_squid.$feature;

_squid.$locale;

_squid.$meta;

_squid.$populate;

_squid.$renderContent;

_squid.$util;

_squid.formatNameInformal;

_squid.$integration;

_auth.$AuthModel;

_choice.$ChoiceEligibility;

_newMember.$NewMemberEligibility;

_index.$TokenizedWalletInfoModel;

_fi.$BillingAddressesModel;

_fi.$PreferredFi;

_fi.$ResolveOTP;

_index2.$CheckoutAppDataModel;

_index2.$CheckoutCartModel;

_index2.$CheckoutSessionModel;

_index2.$FlowEligibilityModel;

_checkoutIncentive.$CreateOfferModel;

_checkoutIncentive.$EvaluateCheckoutOfferEligibilityModel;

_checkoutIncentive.$GetOfferProgramModel;

_util.$fiErrorUtil;

_cardMetaData.$CardMetaData;

_factory.$AddCardFactory;

_factory2.$NoBalanceFactory;

_constants.STATUS_SUCCESS;

_constants.STATUS_API_ERROR;

_constants.STATUS_DECLINE;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-card/addcard/directive.js
// module id = ../node_modules/xo-wallet-components/src/add-card/addcard/directive.js
// module chunks = 0